export const getFullName = (obj) => {
  return obj ? `${obj.firstName || ''} ${obj.lastName || ''}`.trimEnd() : '';
};

export const buildCardSelectEntry = (cardItem) => `•••• •••• •••• ${cardItem.last4}-${cardItem.expMonth.lenth === 1
  ? `0${cardItem.expMonth}` : cardItem.expMonth}/${cardItem.expYear}`;
